export const errorMessages = {
    initialization: 'Cache initialization error: ',
    notEnabled: 'Cache is not enabled.',
    expired: 'Cache entry already expired: ',
    notFound: 'No such key: ',
    browserOffline: 'No entries were deleted, because browser is offline.'
};
